var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95247 6.0952C7.59635 6.0952 8.92867 4.76289 8.92867 3.11901C8.92867 1.47513 7.59635 0.142822 5.95247 0.142822C4.30859 0.142822 2.97628 1.47513 2.97628 3.11901C2.97628 4.76289 4.30859 6.0952 5.95247 6.0952ZM8.03581 6.83925H7.64751C7.13132 7.07642 6.55701 7.21128 5.95247 7.21128C5.34794 7.21128 4.77595 7.07642 4.25744 6.83925H3.86914C2.14388 6.83925 0.744141 8.23899 0.744141 9.96425V10.9315C0.744141 11.5477 1.24405 12.0476 1.86021 12.0476H10.0447C10.6609 12.0476 11.1608 11.5477 11.1608 10.9315V9.96425C11.1608 8.23899 9.76107 6.83925 8.03581 6.83925Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f377002494bda5ddec2e884cad771e97.svg";
export { ForwardRef as ReactComponent };